import { Component, Input, OnInit } from '@angular/core';
import { TerminalStatus } from '../../models/datafox-device.model';

@Component({
    selector: 'status',
    templateUrl: './status.component.html',
    styleUrls: ['./status.component.css'],
    standalone: false
})
export class StatusComponent implements OnInit {

  @Input() status: TerminalStatus = null;

  constructor() { }

  ngOnInit(): void {
  }

  get anyStatus(): boolean {
    return this.status != null && this.status != TerminalStatus.Unknown;
  }

  get offline(): boolean {
    return this.anyStatus && this.status == TerminalStatus.Offline;
  }

  get online(): boolean {
    return this.anyStatus && this.status == TerminalStatus.Online;
  }

  get wait(): boolean {
    return this.anyStatus && this.status == TerminalStatus.Wait;
  }

  public get statusTooltip(): string {
    if (this.offline) {
      return 'Offline';
    } else if (this.online) {
      return 'Online';
    } else if (this.wait) {
      return 'Warten...';
    } else {
      return null;
    }
  }
}
